// @ts-ignore
const isCN = window.schema === 'cn';
const US_HOST = 'us-west-1.log.aliyuncs.com';
const CN_HOST = 'cn-qingdao.log.aliyuncs.com';
const US_PROJECT = 'im-log-us';
const CN_PROJECT = 'im-log-cn';
const US_LOG = 'im-us-logstore';
const CN_LOG = 'im-log-store-cn';
const opts = {
    host: isCN ? CN_HOST : US_HOST,
    project: isCN ? CN_PROJECT : US_PROJECT,
    logstore: isCN ? CN_LOG : US_LOG,
    time: 10,
    count: 10
};
class SlsWebLogger {
    constructor(options) {
        this.options = options;
        const { project, host, logstore } = options;
        this.url = `http://${project}.${host}/logstores/${logstore}/track.gif?APIVersion=0.6.0`;
    }
    send(params) {
        const url = `${this.url}&${stringify(params)}`;
        var name = 'im_log_' + Date.now();
        var img = new Image();
        // @ts-ignore
        window[name] = img;
        img.onload = function () {
            try {
                // @ts-ignore
                window[name] = null;
                // @ts-ignore
                delete window[name];
            }
            catch (e) {
                // empty
            }
            this.onload = null;
        };
        img.src = url;
    }
}
const stringify = (json) => {
    return Object.keys(json)
        .map(function (key) {
        return key + '=' + encodeURIComponent(json[key]);
    })
        .join('&');
};
const slsLogger = new SlsWebLogger(opts);
export default slsLogger;
